module.exports = __webpack_public_path__ + "img/symbol_1.084c2b27.png";